<template>
  <div>
    <div class="log-history-container">
      <!-- Add Internal Note Section -->
      <div class="add-note-section">
        <div class="note-input-container">
          <div class="avatar-top">
            <img class="style_avatar" :src="avatar_url" />
          </div>

          <div class="input-with-button">
            <input
              v-model="internalNote"
              id="internal-note"
              class="note-input"
              placeholder="Add an internal note"
              @keyup.enter="addNote"
            />
            <div class="separator"></div>

            <div class="box-button">
              <button class="noted-button" :disabled="saving" @click="addNote">
                {{ saving ? "Saving..." : "Noted" }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- History -->
      <div class="history-wrap">
        <div class="history-header">
          <div class="header-line"></div>
          <div class="header-title">Change history</div>
          <div class="header-line"></div>
        </div>

        <div v-if="loading && logs.length === 0" class="empty-text">
          Loading...
        </div>

        <div v-else-if="!loading && logs.length === 0" class="empty-text">
          No history yet.
        </div>

        <div v-else class="history-list">
          <div v-for="(log, index) in logs" :key="index" class="history-item">
            <div class="history-avatar">
              <img class="style_avatar" :src="log.avatar || defaultAvatar" />
            </div>

            <div class="history-content">
              <div class="history-meta">
                <span class="history-author">{{ log.author || "Administrator" }}</span>
                <span class="history-sep"> - </span>
                <span class="history-time">{{ log.timestamp }}</span>
              </div>

              <div class="history-note">
                {{ log.note }}
              </div>
            </div>
          </div>

          <!-- Load more (hiện khi còn data) -->
          <div class="load-more-wrap" v-if="logs.length > 0 && hasMore">
            <button
              class="load-more-btn"
              @click="loadMore"
              :disabled="loadingMore"
            >
              {{ loadingMore ? "Loading..." : "Load more" }}
            </button>
          </div>

          <!-- Optional: show "No more" text -->
          <div class="empty-text" v-if="logs.length > 0 && !hasMore">
            No more.
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: {
    log_type: { type: String, required: true },
    object_id: { type: String, required: true },
  },
  data() {
    return {
      internalNote: "",
      logs: [],
      defaultAvatar: "/assets/images/icon/avatar_default.png",

      limit: 8,
      offset: 0,

      loading: false,
      loadingMore: false,
      saving: false,

      totalItem: 0,   // <-- lấy từ API: total_item
      hasMore: true,  // <-- dựa trên totalItem
      avatar_url:null
    };
  },
  mounted() {
    var data_user = this.$AuthenticationApp.getStateLoginNew();
    this.avatar_url = data_user?.avatar_url ?? this.defaultAvatar
    this.fetchChangeHistory(true);
  },
  watch: {
    object_id() {
      this.fetchChangeHistory(true);
    },
    log_type() {
      this.fetchChangeHistory(true);
    }
  },
  methods: {
    async fetchChangeHistory(reset = false) {
      try {
        if (reset) {
          this.loading = true;
          this.offset = 0;
          this.logs = [];
          this.totalItem = 0;
          this.hasMore = true;
        } else {
          this.loadingMore = true;
        }

        const apiUrl = "/api_admin/order/get_log_history";
        const dataRequest = {
          object_id: this.object_id,
          type: this.log_type,
          limit: this.limit,
          offset: this.offset,
        };

        const response = await this.$CoreService.sendApi(apiUrl, dataRequest);

        if (response?.is_success) {
          const total = Number(response?.data?.total_item || 0);
          const rowsRaw = response?.data?.list_data || [];
          const rows = Array.isArray(rowsRaw) ? rowsRaw : (rowsRaw?.rows || rowsRaw?.data || []);

          const mapped = rows.map((r) => ({
            author: r.fullname || "Administrator",
            timestamp: this.formatTime(r.created_at || r.updated_at),
            note: r.note,
            avatar: r.avatar?.url ? r.avatar.url : this.defaultAvatar,
          }));

          // cập nhật total trước
          this.totalItem = total;

          // append hoặc reset
          if (reset) {
            this.logs = mapped;
          } else {
            this.logs = [...this.logs, ...mapped];
          }

          // check hasMore theo total_item
          const loadedCount = this.logs.length;
          this.hasMore = loadedCount < this.totalItem;
        } else {
          console.error("Error fetching change history:", response?.message_text || response);
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
        this.loadingMore = false;
      }
    },

    async loadMore() {
      if (this.loadingMore || !this.hasMore) return;
      this.offset += this.limit;
      await this.fetchChangeHistory(false);
    },

    async addNote() {
      const note = (this.internalNote || "").trim();
      if (!note) return;

      try {
        this.saving = true;

        const apiUrl = "/api_admin/order/add_log";
        const dataRequest = {
          object_id: this.object_id,
          type: this.log_type,
          note,
        };

        const response = await this.$CoreService.sendApi(apiUrl, dataRequest);

        if (response) {
          this.internalNote = "";
          // reload lại trang đầu để thấy item mới nhất + total update
          await this.fetchChangeHistory(true);
        } else {
          console.error("Error add log:", response?.message_text || response);
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.saving = false;
      }
    },

    formatTime(v) {
      if (!v) return "";
      // format theo đúng mẫu bạn đang dùng
      // nếu v là ISO string / timestamp đều ok
      return moment(v).format("DD/MM/YYYY HH:mm:ss");
    },
  },
};
</script>

<style scoped>
/* giữ nguyên toàn bộ style bạn đang có */


.log-history-container {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.add-note-section {
  margin-bottom: 20px;
}

.note-input-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
}

.input-with-button {
  display: flex;
  flex-direction: column;
  width: 100%;
  border: 1px solid #D9D9D9;
  border-radius: 20px;
  padding: 8px;
}

.note-input {
  width: 100%;
  padding: 8px;
  border: none;
  font-size: 14px;
  outline: none;
  border-radius: 20px;
}

.note-input::placeholder {
  color: #bbb;
}

.separator {
  width: 100%;
  height: 1px;
  background-color: #D9D9D9;
  margin: 8px 0;
}

.box-button {
  display: block;
  text-align: right;
}

.noted-button {
  background-color: #FFDF01;
  color: white;
  padding: 8px 16px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  width: auto;
  font-size: 16px;
  font-weight: 500;
}

.noted-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.noted-button:hover {
  background-color: #fcd200;
}

.history-wrap {
  width: 100%;
  background: #fff;
  padding: 0;
  box-sizing: border-box;
}

.history-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 10px 0 14px 0;
}

.header-line {
  flex: 1;
  height: 1px;
  background: #e6e6e6;
}

.header-title {
  font-size: 18px;
  font-weight: 600;
  color: #7a7a7a;
  line-height: 1;
}

.history-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.history-item {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.history-avatar {
  width: 56px;
  height: 56px;
  border: 1px solid #e6e6e6;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
  background:
    linear-gradient(45deg, #f3f3f3 25%, transparent 25%) 0 0/10px 10px,
    linear-gradient(-45deg, #f3f3f3 25%, transparent 25%) 0 0/10px 10px,
    linear-gradient(45deg, transparent 75%, #f3f3f3 75%) 0 0/10px 10px,
    linear-gradient(-45deg, transparent 75%, #f3f3f3 75%) 0 0/10px 10px;
}

.style_avatar {
  width: 56px;
  height: 56px;
}

.history-content {
  padding-top: 2px;
}

.history-meta {
  font-size: 14px;
  line-height: 1.2;
}

.history-author {
  font-weight: 700;
  color: #111;
}

.history-sep,
.history-time {
  font-weight: 400;
  color: #111;
}

.history-note {
  margin-top: 8px;
  font-size: 14px;
  color: #222;
  line-height: 1.35;
}

.avatar-top {
  flex-shrink: 0;
  align-self: flex-start;
  margin-right: 8px;
}

.empty-text {
  font-size: 14px;
  color: #777;
  padding: 8px 0;
}

.load-more-wrap {
  display: flex;
  justify-content: center;
  padding: 10px 0 0 0;
}

.load-more-btn {
  border: 1px solid #e6e6e6;
  background: #fff;
  padding: 10px 18px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
}

.load-more-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}


</style>
